import React, { Suspense, lazy } from 'react';

import {

    Route, Routes
} from "react-router-dom";
import { ComponentLoader } from '../loader/componentLoader';
import { PageLoader } from '../loader/pageLoader';

const SearchResult = lazy(() => import('../search/SearchResult'));
export function Search(props) {


    return <>
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route path={"/"} element={<SearchResult />} />
            </Routes>
        </Suspense>

    </>

}